// top LIST | MAP switch
import { SWITCH_BAR_CLICKED } from './constants'

const setupSwitchButtons = ($) =>
  $('[data-switch-button]').on('click', function(e) {
    e.preventDefault()
    e.stopPropagation()
    $('[data-switch-button]').toggleClass('active')

    const v = $('[data-switch-view]')
    v.toggleClass('hidden')

    const type = $(this).data('switch-view-type')
    $('[data-node-switch-bar]').trigger(SWITCH_BAR_CLICKED, { type })
  })

const setup = ($) => {
  if (!$('[data-node-type="switch_bar"]').get(0)) {
    return
  }
  setupSwitchButtons($)
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/node_switch_bar.js